// Module
var code = "<md-list-item md-ink-ripple class=\"abm-mobile-list-item no-margin elevation-frame-1dp\" role=\"listitem\"> <ng-transclude flex class=\"pad-8-right\"></ng-transclude> <md-icon class=\"material-icons md-accent\">arrow_forward</md-icon> </md-list-item> ";
// Exports
module.exports = code;